import React, { FC } from 'react';
import { HitCommentariesList } from '../hit-commentaries/HitCommentariesList';
import { ItemSeparator } from '../../../../components/item-separator/ItemSeparator';
import { convertDateLawVersion } from '../../search-snippets/main/legislation/legislationSnippetUtils';
import { getFormattedDate } from '../../../../utils/date-utils/dateUtils';
import { ScrollToMe } from '../../../../components/ScrollToMe';
import { getCommentariesLinkedToLegislation } from '../commentaries-modal/legislationApi';
import { SmallLineSeparator } from '../../../../components/separator/LineSeparator';
import { LegislationParts } from './LegislationParts';
import { ExcerptContainer } from '../../../../components/excerpt/Excerpt';
import { LegislationHit } from '../../../search.types';
import { ExcerptTitle } from '../../../../components/excerpt/title/ExcerptTitle';
import { ExcerptSummary } from '../../../../components/excerpt/summary/ExcerptSummary';

type Props = {
  legislation: LegislationHit;
  sources: { hits: string; commentaries: string };
  type: string;
  handleResultClicked: (
    legislation: LegislationHit,
    index: number,
  ) => (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
  legislationUrl: string;
  index: number;
  position: number | null;
};

export const SearchResultLegislationExcerpt: FC<Props> = ({
  legislation,
  legislationUrl,
  type,
  handleResultClicked,
  index,
  sources,
  position,
}) => {
  return (
    <ScrollToMe shouldScroll={position === index + 1}>
      {(ref) => (
        <ExcerptContainer ref={ref}>
          <ItemSeparator />
          <ExcerptTitle
            position={index + 1}
            href={legislationUrl}
            onClick={handleResultClicked(legislation, index)}
          >
            <span dangerouslySetInnerHTML={{ __html: legislation.title }} />
          </ExcerptTitle>
          {!!legislation.startDate && (
            <p>
              {convertDateLawVersion({
                start: legislation.startDate
                  ? getFormattedDate(legislation.startDate)
                  : null,
                end: legislation.endDate
                  ? getFormattedDate(legislation.endDate)
                  : null,
                state: legislation.state,
                prefix: 'En vigueur ',
              })}
            </p>
          )}
          {legislation.parts.length > 0 ? (
            <LegislationParts parts={legislation.parts} />
          ) : (
            <SmallLineSeparator />
          )}
          <ExcerptSummary
            hit={{
              url: legislation.url,
              visited: legislation.visited,
              summary: legislation.preview,
            }}
            source={sources.hits}
            onHitClicked={handleResultClicked(legislation, index)}
          />
          <HitCommentariesList
            commentaries={legislation.comments || []}
            docId={legislation.docId}
            numberOfComments={legislation.numberOfComments}
            nextCommentAuthors={legislation.nextCommentAuthors}
            otherCommentAuthorsCount={legislation.otherCommentAuthorsCount}
            allCommentariesGetter={getCommentariesLinkedToLegislation}
            source={sources.commentaries}
            searchType={type}
          />
        </ExcerptContainer>
      )}
    </ScrollToMe>
  );
};
